export default {
  categories: {
    accessAccount: "Zugang und Konto",
    myActivities: "Meine Aktivitäten",
    bookings: "Buchungen",
    commissions: "Provisionen",
    onSitePayments: "Zahlung vor Ort (Restaurants)",
    wallet: "Wallet",
    tablets: "Tablets und POS",
    support: "Support",
  },
  items: {
    accessHow: {
      question: "Wie erhalte ich Zugang zum Portal?",
      answer: "Nach Vertragsunterzeichnung legt der Flitrip-Support Ihr Konto an. Sie erhalten eine E-Mail an die im Vertrag angegebene Adresse mit einem Link zur Passwortvergabe. Wenn der Link abgelaufen ist oder die E-Mail nicht ankommt, prüfen Sie den Spam-Ordner und öffnen Sie dann eine Support-Anfrage.",
    },
    accessCredentials: {
      question: "Wie ändere ich E-Mail oder Passwort?",
      answer: "Öffnen Sie ein Support-Ticket: Zugangsdaten können derzeit nicht im Portal geändert werden. Wenn sich das Personal, das das Portal nutzt, ändert, fordern Sie umgehend eine Passwortänderung an. Der Zugang ist einzigartig und geteilt – bis zur Änderung kann jeder, der ihn früher hatte, ihn weiter nutzen.",
    },
    accessCollaborator: {
      question: "Kann ich einen Zugang für einen Mitarbeiter anlegen?",
      answer: "Nein, es gibt nur ein Konto. Sie können es mit Personen teilen, die mit Ihnen arbeiten – beachten Sie, dass Aktionen im Portal keiner bestimmten Person zugeordnet werden können.",
    },
    accessClose: {
      question: "Wie beende ich die Zusammenarbeit mit Flitrip?",
      answer: "Öffnen Sie ein Support-Ticket. Es gelten die Kündigungsbedingungen Ihres Vertrags.",
    },
    accessApp: {
      question: "Gibt es eine App zum Installieren?",
      answer: "Nein, Flitrip ist eine Web-App: Sie nutzen sie im Browser, auch auf dem Smartphone. Wenn Sie oft vom Handy zugreifen, fügen Sie den Link zum Startbildschirm hinzu. Auf dem iPhone: Teilen → Zum Home-Bildschirm; auf Android: Browser-Menü → Zum Startbildschirm hinzufügen. Von dort öffnet sie sich wie eine normale App.",
    },
    activitiesAdd: {
      question: "Wie füge ich eine neue Aktivität hinzu?",
      answer: "Aktivitäten werden vom Flitrip-Support angelegt. Öffnen Sie ein Ticket mit Name, Beschreibung, Dauer, Preis, Kapazität und Fotos – wir veröffentlichen sie für Sie. Danach verwalten Sie sie selbst.",
    },
    activitiesEdit: {
      question: "Was kann ich selbst ändern?",
      answer: "Bei einer veröffentlichten Aktivität können Sie Preise, Kalender und Verfügbarkeit, Fotos und Beschreibung ändern – Änderungen sind sofort online, ohne Support. Bei Preisänderungen bleiben bestätigte Buchungen zum vom Gast gezahlten Betrag; die Änderung gilt nur für künftige Buchungen. Erstellen oder Löschen einer Aktivität geht nicht selbst.",
    },
    activitiesDescription: {
      question: "Wozu dient die Beschreibung meiner Aktivität?",
      answer: "Die Beschreibung ist nicht nur zum Lesen: Sie ist die Quelle, aus der der Sprachassistent Gästefragen beantwortet. Fehlt eine Information dort, kann der Assistent sie nicht liefern – und ein Gast ohne Antwort bucht selten.",
    },
    activitiesLanguages: {
      question: "In welchen Sprachen werden meine Aktivitäten angezeigt?",
      answer: "Beschreibungen werden automatisch übersetzt – Sie müssen nichts tun. Der Gast stellt das Tablet auf seine Sprache ein und der Sprachassistent spricht diese Sprache.",
    },
    activitiesAvailability: {
      question: "Wie verwalte ich Kalender und Verfügbarkeit?",
      answer: "Unter Aktivitäten → [Aktivitätsname] → Verfügbarkeit legen Sie buchbare Tage und Zeitfenster, maximale Teilnehmerzahl und Schließtage für Urlaub oder Betriebsferien fest. An geschlossenen Tagen bleibt die Aktivität sichtbar, aber nicht buchbar; Sie öffnen wieder, wann Sie wollen. Bei sehr langen Schließungen öffnen Sie ein Support-Ticket.",
    },
    activitiesDelete: {
      question: "Wie lösche ich eine Aktivität?",
      answer: "Das Löschen muss per Support-Ticket beantragt werden. Wenn Sie Buchungen nur vorübergehend stoppen wollen, schließen Sie Termine unter Verfügbarkeit – sofort und rückgängig machbar.",
    },
    activitiesPhotos: {
      question: "Welche Anforderungen gelten für Fotos?",
      answer: "JPG und PNG werden akzeptiert. Es gibt kein Größenlimit, aber unter 2 MB pro Bild und etwa 2000 Pixel lange Seite vermeiden Sie langsame Uploads auf Tablets. Das erste Foto ist das Titelbild – wählen Sie ein gut erkennbares Motiv im Querformat. Keine Logos, Wasserzeichen, überlagerten Text oder Collagen. iPhone-Fotos sind oft HEIC (nicht akzeptiert): Einstellungen → Kamera → Formate → Maximale Kompatibilität, oder vor dem Upload konvertieren.",
    },
    bookingsHandshake: {
      question: "Was ist Handshake und soll ich ihn aktivieren?",
      answer: "Handshake bestimmt, was bei einer neuen Buchung passiert. Sie schalten ihn unter Einstellungen → Profil ein oder aus; er gilt für alle Ihre Aktivitäten. Handshake an: Jede Buchung kommt als Anfrage; Sie können bestätigen, ablehnen oder verschieben und mit dem Gast chatten. Nützlich bei begrenzten Plätzen, Filterbedarf oder Absprache der Zeiten. Handshake aus: Jede Buchung wird automatisch bestätigt. Sie müssen nichts überwachen, können aber weder verschieben noch den Gast kontaktieren – dafür nur über den Support. Ohne Handshake bleibt bei einer nicht leistbaren Buchung nur Stornierung.",
    },
    bookingsNotifications: {
      question: "Wie erhalte ich Buchungsbenachrichtigungen?",
      answer: "Per E-Mail oder WhatsApp – wählen Sie unter Einstellungen → Profil. Alle Buchungen finden Sie zusätzlich unter Buchungen.",
    },
    bookingsNoConfirm: {
      question: "Was passiert, wenn ich eine Buchung nicht bestätige?",
      answer: "Nur mit aktivem Handshake. Nach 15 Minuten ohne Antwort erhalten Sie einen automatischen Anruf mit den Buchungsdetails: Taste 1 bestätigt sofort ohne Portal. Die Nummer hat internationale Vorwahl +1 – kein Spam, am besten speichern. Ohne Reaktion auf Benachrichtigung oder Anruf verfällt die Anfrage nach 8 Stunden Inaktivität und der Gast wird erstattet.",
    },
    bookingsLeadTime: {
      question: "Wie viel Vorlaufzeit ist für Buchungen nötig?",
      answer: "Sie legen das im Profil fest: wie viele Stunden vorher ein Gast noch buchen kann. Richten Sie es an Ihrer tatsächlichen Vorbereitungszeit aus. Gäste buchen oft abends vom Zimmer-Tablet für denselben Abend – zu großer Vorlauf kostet häufige Buchungen.",
    },
    bookingsCancel: {
      question: "Kann ich eine bestätigte Buchung stornieren?",
      answer: "Ja, jederzeit über die Buchung. Der Gast wird sofort erstattet. Prüfen Sie Alternativen: Mit Handshake können Sie verschieben oder in der Chat abstimmen. Ohne Handshake öffnen Sie ein Ticket – der Support kann den Gast kontaktieren. Ein verschobener Gast ist besser als ein erstatteter.",
    },
    bookingsReschedule: {
      question: "Kann ich eine Buchung verschieben oder die Personenzahl ändern?",
      answer: "Nur mit aktivem Handshake über die Buchung. Ohne Handshake nur über Support oder durch Stornierung.",
    },
    bookingsGuestId: {
      question: "Wie erkenne ich den Gast bei Ankunft?",
      answer: "Anhand von Vor- und Nachname unter Buchungen. Bei Bestätigung erhält der Gast ein PDF per WhatsApp oder E-Mail – im Zweifel darum bitten, es auf dem Handy zu zeigen.",
    },
    bookingsContactGuest: {
      question: "Wie kontaktiere ich einen Gast vor dem Erlebnis?",
      answer: "Mit Handshake über den Chat in der Buchung. Ohne Handshake per Support-Ticket – direkte Kontaktdaten des Gastes erhalten Sie nicht.",
    },
    bookingsOverbooking: {
      question: "Kann ich mehr Buchungen bekommen, als ich bewältigen kann?",
      answer: "Nein. Das System orientiert sich an Ihrer Verfügbarkeit: Ist ein Zeitfenster voll, ist es nicht mehr buchbar. Das gilt nur für Flitrip – nicht für Telefon- oder Walk-in-Gäste. Planen Sie die Kapazität entsprechend.",
    },
    commissions: {
      question: "Wie hoch sind die Provisionen?",
      answer: "Die Provision richtet sich nach Ihrem Vertrag. Bei Unklarheiten zu einer Berechnung wenden Sie sich an den Support.",
    },
    paymentsOnSite: {
      question: "Wie werde ich bezahlt?",
      answer: "Der Gast zahlt Sie vor Ort nach dem Service direkt. Flitrip kassiert nichts für Sie; es gibt keinen ausstehenden Saldo.",
    },
    paymentsReceiptWhy: {
      question: "Warum muss ich den Beleg hochladen?",
      answer: "Der Beleg ermöglicht die Provisionsberechnung laut Vertrag. Ohne Beleg gilt die Buchung nicht als abgeschlossen. Laden Sie das Foto am Ende des Service über die Buchung hoch – am besten vor Feierabend.",
    },
    paymentsReceiptHow: {
      question: "Was genau soll ich fotografieren?",
      answer: "Den Beleg oder die Rechnung für diese Buchung mit lesbarem Betrag und Datum. Ein scharfes Handyfoto reicht.",
    },
    walletPayouts: {
      question: "Wann erhalte ich Zahlungen?",
      answer: "Gemäß Fristen und Bedingungen Ihres Vertrags – ohne Auszahlungsantrag. In der Wallet sehen Sie jederzeit Saldo und Bewegungen.",
    },
    walletReports: {
      question: "Wie erhalte ich Auswertungen für meinen Steuerberater?",
      answer: "Per Support-Ticket mit gewünschtem Zeitraum. Saldo und Bewegungen können Sie jederzeit in der Wallet einsehen.",
    },
    tabletsHow: {
      question: "Wie funktioniert Flitrip in meiner Unterkunft?",
      answer: "Flitrip installiert Tablets mit POS in den Zimmern; Gäste entdecken und buchen Erlebnisse, Services und Restaurants per Sprachassistent in ihrer Sprache. Pro Buchung über Ihre Tablets erhalten Sie laut Vertrag Provision. Sie verkaufen nichts – halten Sie die Geräte einsatzbereit.",
    },
    tabletsOwnership: {
      question: "Gehören mir die Geräte?",
      answer: "Nein. Tablet und POS sind Leihgeräte von Flitrip und bleiben Flitrip-Eigentum; bei Vertragsende holen wir sie ab.",
    },
    tabletsDuty: {
      question: "Wofür bin ich verantwortlich?",
      answer: "Dass Geräte geladen, sichtbar und nutzbar sind. Ein leeres oder verstecktes Tablet erzeugt keine Buchungen und keine Provision.",
    },
    tabletsBroken: {
      question: "Ein Gast sagt, das Tablet funktioniert nicht",
      answer: "Zwei Fälle: Zahlung fehlgeschlagen – Gast kann am Tablet erneut versuchen, keine Meldung nötig. Gerät defekt – Ticket mit Zimmernummer; wir tauschen ohne Kosten für Sie.",
    },
    tabletsDamage: {
      question: "Was, wenn ein Gast ein Tablet beschädigt oder mitnimmt?",
      answer: "Flitrip trägt das Risiko. Ihnen wird nichts berechnet – bitte per Ticket melden, damit wir das Gerät ersetzen können.",
    },
    tabletsEarnings: {
      question: "Wo sehe ich meine Einnahmen?",
      answer: "Unter Buchungen die Historie Ihrer Tablet-Buchungen, in der Wallet Saldo und Bewegungen. Gästedaten sind vertraulich und nur für den Service zu nutzen.",
    },
    tabletsGuestIssue: {
      question: "Ein Gast hat ein Problem mit einer Buchung – was tun?",
      answer: "Gast an Flitrip-Support verweisen (Hinweise auf Tablet und in der Buchungsbestätigung). Wir kümmern uns – Sie müssen nicht lösen.",
    },
    tabletsOwnActivities: {
      question: "Kann ich auch eigene Aktivitäten veröffentlichen?",
      answer: "Ja. Dann kommt ein Partner-Profil zum Host-Profil; im Portal verwalten Sie auch Aktivitäten und Buchungen. Aktivierung per Support-Ticket.",
    },
    tabletsReturn: {
      question: "Was passiert mit den Geräten bei Vertragsende?",
      answer: "Wir holen Tablet und POS ab. Sie müssen nichts versenden oder organisieren.",
    },
    supportTicket: {
      question: "Wie öffne ich ein Ticket?",
      answer: "Hilfe & Support → Ticket senden. Status unter Meine Tickets verfolgen.",
    },
  },
} as const;
